import { ViewMode } from '@mobile-mapping/web3d';
import { TempSvgIcon } from '@tcweb/connect-ui';

/* eslint-disable @typescript-eslint/naming-convention */
export const VIEW_MODE_ICONS: Record<ViewMode['type'], TempSvgIcon | string> = {
  '3D': 'tc-icon-3D-group',
  '2D': 'svg-map-outline',
  Image: 'svg-image-scene-outline',
  Panorama: 'svg-photo-360',
};
